export const BASE = 'USER_INFO_CARD';
export const BASE_RECIPIENT = `${BASE}_RECIPIENT`;
export const LOAD_RECIPIENT_START = `${BASE_RECIPIENT}_START`;
export const LOAD_RECIPIENT_SUCCESS = `${BASE_RECIPIENT}_SUCCESS`;
export const LOAD_RECIPIENT_FAIL = `${BASE_RECIPIENT}_FAIL`;

export const LOAD_GROUPS = `LOAD_${BASE}_GROUPS`;
export const LOAD_GROUPS_START = `${LOAD_GROUPS}_START`;
export const LOAD_GROUPS_SUCCESS = `${LOAD_GROUPS}_SUCCESS`;
export const LOAD_GROUPS_FAIL = `${LOAD_GROUPS}_FAIL`;

export const LOAD_MORE_GROUPS = `LOAD_MORE_${BASE}_GROUPS`;
export const LOAD_MORE_GROUPS_START = `${LOAD_MORE_GROUPS}_START`;
export const LOAD_MORE_GROUPS_SUCCESS = `${LOAD_MORE_GROUPS}_SUCCESS`;
export const LOAD_MORE_GROUPS_FAIL = `${LOAD_MORE_GROUPS}_FAIL`;

export const INITIAL_GROUP_LIMIT = 100;

export function loadRecipient(userUuid) {
  return {
    type: BASE_RECIPIENT,
    userUuid,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${userUuid}`,
      method: 'get',
    },
  };
}

export function getGroups({ userUuid, startIndex, stopIndex, action }) {
  const limit = Math.max(1, stopIndex - startIndex);
  const params = {
    offset: startIndex,
    limit,
  };
  return {
    type: action,
    userUuid,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${userUuid}/groups`,
      params,
      method: 'get',
    },
  };
}

export function loadRecipientGroups(userUuid) {
  return getGroups({
    userUuid,
    startIndex: 0,
    stopIndex: INITIAL_GROUP_LIMIT,
    action: LOAD_GROUPS,
  });
}

export function loadMoreRecipientGroups(parameters) {
  return getGroups({
    ...parameters,
    action: LOAD_MORE_GROUPS,
  });
}

export function resetRecipient(userUuid) {
  return {
    type: 'USER_INFO_CARD_RESET_RECIPIENT',
    userUuid,
  };
}

export function loadUserSupervisors(userUuid) {
  return {
    type: BASE_RECIPIENT,
    userUuid,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${userUuid}/supervisors`,
      method: 'get',
    },
  };
}
